export const COMPACT_CURRENCY_LABELS = {
  newShekel: "₪",
  oldShekel: "שקל",
  lira: "לירה",
  usd: "$"
};
